import React from "react";
import { useDispatch } from "react-redux";
import { showNavbar } from "../../store/modules/appStateSlice";
import GlobalSettingsWidget from './GlobalSettingsWidget';

const GlobalSettingsPage = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(showNavbar(true));
  }, []);
  return (
    <React.Fragment>
      <GlobalSettingsWidget />
    </React.Fragment>
  );
};

export default GlobalSettingsPage;
